import React, {useCallback} from 'react'
import {useDropzone} from 'react-dropzone'

const DragAndDrop = (props) => {
    const onDrop = useCallback((acceptedFiles, fileRejections) => {
        // if (fileRejections?.length) {
        //     return TB.toast(TB.first(TB.first(fileRejections).errors).message,{"theme":'danger'})
        // }
        props.handleDrop(acceptedFiles);
    }, [])
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        // maxSize: 100000,
        accept: props.accept || 'image/*',
        multiple: false,
        disabled: props.disabled
    })

    return (
        <div {...getRootProps()} className={"image-drop-input " + (isDragActive && 'drag-active')}>
            <input {...getInputProps()} name={props.name}/>
            {props.dropContainer || (
                <div className="btn-file">
                    {props.before || null}
                    {isDragActive ? <p>Drop the files here ...</p> : [
                        <p key={"image-drop-instructions"}>
                            To upload a {props.type || 'photo'} drag here or
                            <b className="text-primary">
                                browse
                            </b>
                        </p>,
                        <i key="image-drop-instructions-icon" className="fas fa-plus-circle ml-2" />
                    ]}
                </div>
            )}

        </div>
    )
}

export default DragAndDrop;